// extracted by mini-css-extract-plugin
export var messageSideLeft = "_ne-1";
export var stateContainer = "_ne-0";